export default "__VITE_ASSET__D0L8eqQD__"